import { ByggKundeResult } from './ByggKundeResult';
import type { IByggKunde } from './IByggKunde';

export class ByggKunde implements IByggKunde {
    private _kundeNummer: string;
    private _kundeNavn: string;
    private _byggNummer: string;
    private _byggNavn: string;
    private _selected?: boolean;

    private _group?: boolean;
    private _children: Array<ByggKunde> = [];
    private _selectedChildrenCount = 0;

    public constructor(params: IByggKunde) {
        this._kundeNummer = params.kundeNummer;
        this._kundeNavn = params.kundeNavn;
        this._byggNummer = params.byggNummer;
        this._byggNavn = `${params.byggNummer} ${params.byggNavn}`;

        this._group = params.group;
        this._children = params.children || [];
    }

    public static parseObject(obj: IByggKunde): ByggKunde {
        try {
            return new ByggKunde(obj);
        } catch (e) {
            throw new Error(
                `Couldn't parse object: ${JSON.stringify(obj)} ${e}`,
            );
        }
    }

    public get kundeNummer() {
        return this._kundeNummer;
    }
    public get kundeNavn() {
        return this._kundeNavn;
    }
    public get byggNummer() {
        return this._byggNummer;
    }
    public get byggNavn() {
        return this._byggNavn;
    }

    public get kundeBygg() {
        return `${this._kundeNummer}-${this._byggNummer}`;
    }

    public get group() {
        return !!this._group;
    }

    public set group(value: boolean) {
        this._group = value;
    }

    public get children() {
        return this._children;
    }

    public resetChildren() {
        this._children = [];
    }

    public get selected() {
        const { _group, _selected, _selectedChildrenCount, _children } = this;
        return _group
            ? _children !== undefined &&
                  _selectedChildrenCount === _children.length
            : !!_selected;
    }

    public set selected(selected: boolean) {
        this._selected = selected;
    }

    public addChild(element: ByggKunde) {
        this._children = [...this._children, element];
        if (element.selected) {
            this._selectedChildrenCount++;
        }
    }

    public toResult = () => {
        const { kundeNummer, byggNummer } = this;
        return new ByggKundeResult({
            kundeNummer,
            byggNummer,
        });
    };
}
